import { useQuery } from '@tanstack/react-query';
import { EmptyArray } from '@thinkalpha/common/util/iterators.js';
import { getIndicatorViewModels } from 'src/lib/dictionary/dictionary';
import type { RootState } from 'src/store';
import { useSelector } from 'src/store/hooks';

const selectUser = (state: RootState) => state.auth.masqUser ?? state.auth.user;
export const useUser = () => useSelector(selectUser);

export const selectAccessToken = (state: RootState) => state.auth.masqAccessToken ?? state.auth.accessToken;
export const useAccessToken = () => useSelector(selectAccessToken);

export const useGetIndicators = () => {
    const { data } = useQuery({
        queryKey: ['indicators'],
        queryFn: () => getIndicatorViewModels(),
        placeholderData: EmptyArray,
    });

    // ToDo: Figure out serialization issue causing indicators to serialize to []
    if (!Array.isArray(data)) {
        return [];
    }

    return data ?? EmptyArray;
};
